var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-page-loading-indicator',{attrs:{"loading":_vm.isDataLoading && _vm.apiPageFailure.length === 0}},[_c('asc-container',{staticClass:"asc-feature-flags-container"},[_c('asc-feature-flags-template')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }